function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import InputLikeCheckboxRadio from 'components/Form/InputLikeCheckboxRadio';
import Button from 'components/Form/Button';
import keyPairShape from 'shapes/keyPairShape';
import App from 'modules/App';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from './SetCloudDrive.pcss';
var _React_PureComponent;
class SetCloudDrive extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        if (props.route.name !== 'setup' && props.route.name !== 'setup-mobile' && props.route.name !== 'add-drive') {
            return {
                isInProgress: true
            };
        }
        if (props.isInProgress !== state.isInProgress) {
            if (!props.isInProgress && !props.hasErrors) {
                return null;
            }
            return {
                isInProgress: props.isInProgress
            };
        }
        return null;
    }
    get isInProgress() {
        return this.state.isInProgress || !!this.props.authorizationCode;
    }
    renderProgress() {
        return /*#__PURE__*/ _jsx("p", {
            className: "text--h3 mb-5",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.configuringCloudDrive))
        });
    }
    renderActions() {
        const { type } = this.props;
        const cloudDrive = get(this.props.formValues, 'values.storageProvider');
        return /*#__PURE__*/ _jsx("div", {
            className: "row",
            children: /*#__PURE__*/ _jsx("div", {
                className: "col-12 col-md-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    id: "set-storage-type",
                    type: "button",
                    styleModifier: "primary",
                    labelMessage: messages.buttons.setCloudDrive,
                    className: "btn--block btn--filled",
                    isInProgress: this.isInProgress,
                    isDisabled: !this.isInProgress && this.props.isDisabled,
                    onClick: ()=>this.props.onAuthorizeCloudDrive(cloudDrive, type)
                })
            })
        });
    }
    renderForm() {
        return /*#__PURE__*/ _jsxs(Form, {
            children: [
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "storageProvider",
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(InputLikeCheckboxRadio, {
                        labelMessage: App.constants.CLOUD_DRIVES_LABELS.CentralStorage,
                        inputValue: "CentralStorage",
                        containerClassName: "col-12",
                        isRadio: true,
                        isDisabled: this.props.isDisabled,
                        onChange: this.props.onSetFormValue
                    })
                }),
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "storageProvider",
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(InputLikeCheckboxRadio, {
                        labelMessage: App.constants.CLOUD_DRIVES_LABELS.GoogleDrive,
                        inputValue: "GoogleDrive",
                        containerClassName: "col-12",
                        isRadio: true,
                        isDisabled: this.props.isDisabled,
                        onChange: this.props.onSetFormValue
                    })
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            "data-testid": "set-up-cloud-drive-section",
            children: [
                this.isInProgress ? this.renderProgress() : this.renderForm(),
                this.renderActions()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isInProgress: false
        };
        if (!props.formValues || !props.formValues.storageProvider) {
            props.onSetFormValues({
                storageProvider: 'CentralStorage'
            });
        }
    }
}
_define_property(SetCloudDrive, "propTypes", {
    // Explicit props
    type: PropTypes.string.isRequired,
    keyPair: keyPairShape.isRequired,
    formValues: PropTypes.object,
    isInProgress: PropTypes.bool,
    isDisabled: PropTypes.bool,
    hasErrors: PropTypes.bool,
    // Explicit actions
    onSetFormValue: PropTypes.func.isRequired,
    onSetFormValues: PropTypes.func.isRequired,
    // Implicit props
    authorizationCode: shapes.authorizationCode,
    route: App.shapes.route,
    // Implicit actions
    onAuthorizeCloudDrive: PropTypes.func
});
const mapStateToProps = (state)=>({
        authorizationCode: selectors.authorizationCode(state),
        route: App.selectors.route(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onAuthorizeCloudDrive: (provider, type)=>dispatch(actions.authorize(provider, type))
    });
const ConnectedSetCloudDrive = connect(mapStateToProps, mapDispatchToProps)(SetCloudDrive);
export default withStyles(styles)(ConnectedSetCloudDrive);
